module.exports = __webpack_public_path__ + "static/media/huoshishan3.bd60dd99.webp";